import "./pagination.scss";

const pagination = {
    init: () => {

        pagination.navigatePagination();
        pagination.setPaginationDefault();
        pagination.setPaginationButtons();
        pagination.clickPaginationScroll();
    },
    navigatePagination: () => {
        const paginationItems = document.querySelectorAll(".pagination__item[data-page]");

        paginationItems.forEach((paginationItem) => {
            paginationItem.addEventListener("click", (e) => {
                e.preventDefault();
                navigate(e);
            });

            paginationItem.addEventListener("touchstart", (e) => {
                e.preventDefault();
                navigate(e);
            });
        });

        function navigate(p: Event) {
            const target = p.target as HTMLElement;

            if (target) {
                const dataItem = target.dataset.page as string;
                const urlParams = new URLSearchParams(window.location.search);

                if (window.location.search === "") {
                    window.location.href = `?page=${dataItem}`
                }
                else {
                    const hasPagination = urlParams.has("page");

                    if (hasPagination) {
                        urlParams.set('page', dataItem);
                        const urlString = urlParams.toString();

                        window.location.href = window.location.pathname + `?${urlString}`;
                    }
                    else {
                        window.location.href = window.location.href + `&page=${dataItem}`
                    }
                }
            }

        }
    },
    setPaginationDefault: () => {
        const slider = document.getElementById("pagination-slider");

        if (slider !== null) {
            const currentItem = document.querySelector(".pagination__item.active");

            if (currentItem !== null) {
                const parentItem = currentItem.closest(".pagination-slide");

                if (parentItem) {
                    const currentSlide = parentItem.getAttribute("data-slide");

                    slider.style.setProperty("--slider__index", currentSlide);
                }
            }
        }
    },
    setPaginationButtons: () => {
        const slider = document.getElementById("pagination-slider");

        if (slider !== null) {
            const sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider__index"));
            const buttonPrev = document.getElementById("pagination-prev");
            const buttonNext = document.getElementById("pagination-next");

            const slides = Number(slider.querySelectorAll(".pagination-slide").length);

            if (buttonPrev && buttonNext) {
                const slidesAmount = slides - 1;

                if (slidesAmount === 0) {
                    buttonPrev.setAttribute("disabled", "");
                    buttonNext.setAttribute("disabled", "");
                }
                else if (slidesAmount > 0) {
                    if (sliderIndex === 0) {
                        buttonPrev.setAttribute("disabled", "");
                        buttonNext.removeAttribute("disabled");
                    }
                    if (sliderIndex > 0 && sliderIndex < slidesAmount) {
                        buttonPrev.removeAttribute("disabled");
                        buttonNext.removeAttribute("disabled");
                    }
                    if (sliderIndex === slidesAmount) {
                        buttonPrev.removeAttribute("disabled");
                        buttonNext.setAttribute("disabled", "");
                    }
                }
            }
        }
    },
    clickPaginationScroll: () => {
        const slider = document.getElementById("pagination-slider");
        const buttonPrev = document.getElementById("pagination-prev");
        const buttonNext = document.getElementById("pagination-next");
        let sliderIndex: number;

        if (slider) {
            sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider__index"));
        }

        if (buttonPrev && buttonNext) {
            buttonPrev.addEventListener("click", () => {
                if (slider && sliderIndex) {
                    sliderIndex = sliderIndex - 1;

                    slider.style.setProperty("--slider__index", sliderIndex.toString());

                    pagination.setPaginationButtons();
                }
            });

            buttonNext.addEventListener("click", () => {
                sliderIndex = sliderIndex + 1;

                if (slider) {
                    slider.style.setProperty("--slider__index", sliderIndex.toString());

                    pagination.setPaginationButtons();
                }
            });
        }

    }
}

export { pagination }